<template>
  <div class="selectstyle">
    <!-- 下拉加多选框 -->
    <el-select
        v-model="value"
        multiple
        placeholder="请选择"
        :popper-append-to-body="false"
        @remove-tag="options"
    >
        <el-option
            v-for="(item,index) in options"
            :key="index"
            :label="item.label"
            :value="item.label"
            @change="handleItemclick(item)"
            >
            <el-checkbox v-model="item.check" @change="isChecked(item)" style="">
                {{ item.label }}
            </el-checkbox>
        </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
    name: 'SelectChecked',
    components: {},
    props: {
        options:{
            type: Array
        }
    },
    data() {
        return {
            value: []
        }
    },
    methods:{
        // 点击选项触发
        handleItemclick(item){
            if(this.value.indexOf(item.label) != -1){
                // 选中状态
                for(let o of this.options){
                    if (o.label == item.label) {
                        o.check = true
                    }
                }
            }
            // else{
            //     // 未选中状态
            //     for(let o of this.options){
            //         if (o.label == item.label) {
            //             o.check = false
            //         }
            //     }
            // }
           
            //// console.log(item)
        },
        // 多选框触发
        isChecked(item) {
            //// console.log(this.value)
            if(item.check && this.value.indexOf(item.label) == -1){ //如果 选中了, 并且value没有
                this.value.push(item.label)
            }else if(!item.check){ //如果没选中
                this.value.forEach((one, idx) => {
                    if (one == item.label) {
                        this.value.splice(idx, 1)
                    }
                })
            }
        this.$emit('selectedVal', this.value)
        },
        // 多选模式下移除tag时触发
        removeTag(value) {
            this.options.forEach((elm, idx) => {
                if (elm.value == value) {
                elm.check = false
                }
            })
            this.$emit('selectedVal', this.value)
        }
    }
}
</script>

<style lang="less" scoped>
.select-checked {
  .el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
    content: '';
  }
  .el-checkbox {
    width: 100%;
    padding: 0 30px;
    .el-checkbox__label {
      margin-left: 20px;
    }
  }
  .el-select-dropdown__item {
    padding: 0;
  }
}
/deep/ .selectstyle{
    .el-select-dropdown__item{
        position: relative;
        .el-checkbox{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            background-color: #c00;
        }
    }
}
</style>